import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { FTEViewId } from "@agentx/agentx-services";
import { Router } from "@uuip/unified-ui-platform";
import { html, nothing } from "lit-html";
import style from "./QueueStatsBlock.scss";
const QueueStatsBlock = () => {
    var _a;
    const completeFTE = () => {
        STORE.app.completeFTE(FTEViewId.QUEUE_STATS);
    };
    const shouldShowFTE = STORE.app.shouldShowFTE && !STORE.app.isQueueStatsFTEViewCompleted;
    return new Router.RouterView.Block({
        template: html `
      <div class="queues-stats">
        ${shouldShowFTE
            ? html `
              <agentx-wc-first-user-experience
                .title=${t("app:fte.queueStats.title")}
                info-message=${t("app:fte.queueStats.message")}
                info-message-secondary=${t("app:fte.queueStats.messageSecondary")}
                illustration-type="QueueStats"
                .isDarkMode=${STORE.app.darkMode}
                @close=${completeFTE}
                @got-it=${completeFTE}
                @outside-close=${completeFTE}
              ></agentx-wc-first-user-experience>
            `
            : nothing}
        <agentx-wc-panel-frame heading=${t("app:queueStats.pageTitle")}>
          <agentx-wc-queue-stats-landing
            class="queues-stats-landing"
            .isDarkMode=${STORE.app.darkMode}
            .isExpanded=${(_a = STORE.layout.getRouterViewClasses.expanded) !== null && _a !== void 0 ? _a : false}
            .isRTDIntialized=${STORE.app.isRTDIntialized}
            selectedQueueId=${STORE.agentContact.getSelectedQueueId}
            .orgId=${STORE.agent.orgId}
            ?isAgentQueueManagementEnabled=${STORE.app.featureFlags.isAgentQueueManagementEnabled}
            @action-button-open-details=${(e) => {
            STORE.layout.setRouterViewClasses({ expanded: true });
            STORE.agentContact.selectedQueueStatsQueueChange(e.detail.context.eventId);
        }}
            @queue-selected=${(e) => {
            STORE.agentContact.selectedQueueStatsQueueChange(e.detail.queueId);
        }}
            @grid-sidebar-toggled=${(e) => {
            STORE.layout.setRouterViewClasses({ "with-sidebar": e.detail.visible });
        }}
          ></agentx-wc-queue-stats-landing>
        </agentx-wc-panel-frame>
      </div>
    `,
        styles: [style]
    });
};
export default QueueStatsBlock;
